import { Suspense, lazy } from "react";
import {
  type iRoute,
  type iRoutesData,
  getHyphenFromCamelCase,
} from "@rotorstudios/fe-modules";

import { A_SECTION_MOUNT, A_SECTION_UNMOUNT } from "../../../animations/aAnimationStates";
import { PAGE_HOME, PAGE_VEHICLE_SELECTION, PAGE_NEXT_STEPS, PAGE_ERROR } from "./static";

// Lazy-loaded Pages
const VehicleSelection = lazy(() => import("../../../../Pages/VehicleSelection"));
const Home = lazy(() => import("../../../../Pages/Home"));
const NextSteps = lazy(() => import("../../../../Pages/NextSteps"));
const ErrorPage = lazy(() => import("../../../../Pages/Error"));

// TODO fix fe-modules to export types properly
type RoutesDataType = typeof iRoutesData;
type iRoutes = typeof iRoute;

// TODO create this object from data iteration
export const ROUTES_DATA: RoutesDataType = new Map([
  // *************
  // Pages
  // *************
  [
    PAGE_VEHICLE_SELECTION,
    {
      id: PAGE_VEHICLE_SELECTION,
      path: getHyphenFromCamelCase(PAGE_VEHICLE_SELECTION),
      isExact: true,
      element: (
        <Suspense fallback={null}>
          <VehicleSelection />
        </Suspense>
      ),
      stateOnMount: A_SECTION_MOUNT,
      stateOnUnmount: A_SECTION_UNMOUNT,
    },
  ],
  [
    PAGE_HOME,
    {
      id: PAGE_HOME,
      path: getHyphenFromCamelCase(PAGE_HOME),
      isExact: false,
      element: (
        <Suspense fallback={null}>
          <Home />
        </Suspense>
      ),
      stateOnMount: A_SECTION_MOUNT,
      stateOnUnmount: A_SECTION_UNMOUNT,
    },
  ],
  [
    PAGE_NEXT_STEPS,
    {
      id: PAGE_NEXT_STEPS,
      path: getHyphenFromCamelCase(PAGE_NEXT_STEPS),
      isExact: false,
      element: (
        <Suspense fallback={null}>
          <NextSteps />
        </Suspense>
      ),
      stateOnMount: A_SECTION_MOUNT,
      stateOnUnmount: A_SECTION_UNMOUNT,
    },
  ],
  [
    PAGE_ERROR,
    {
      id: PAGE_ERROR,
      path: getHyphenFromCamelCase(PAGE_ERROR),
      isExact: true,
      element: (
        <Suspense fallback={null}>
          <ErrorPage />
        </Suspense>
      ),
      stateOnMount: A_SECTION_MOUNT,
      stateOnUnmount: A_SECTION_UNMOUNT,
    },
  ],
]);

export const ROUTES_PAGES_MAIN_TREE: iRoutes[] = [
  // Vehicle Selection
  ROUTES_DATA.get(PAGE_VEHICLE_SELECTION),
  // Home
  ROUTES_DATA.get(PAGE_HOME),
  // Next Steps
  ROUTES_DATA.get(PAGE_NEXT_STEPS),
  // Error
  ROUTES_DATA.get(PAGE_ERROR),
];
